<template>
  <div>
    <el-card>
      <div class="topHeader clearfix">
        <div>
          <span class="userName">
            当前登录: <span>{{ userName }}</span>
          </span>
          <div>
            <el-link v-if="this.eProcList.length >= 2 && mode == 1" :underline="false" class="retHome" type="primary" @click="exitHome">
              <i class="el-icon-switch-button"></i> 切换登录</el-link
            >
          </div>
        </div>

        <el-header :class="{ head_read: true }">
          <el-form ref="readFormRef" :model="readForm" class="readForm" label-width="160px">
            <el-form-item :rules="[{ required: true }]" label="RFID：" prop="rfid_no" size="samll">
              <el-input
                ref="cardRef"
                v-model="readForm.rfid_no"
                :disabled="isDisabled"
                class="readInput"
                placeholder="请刷卡"
                show-word-limit
                @input="cardChange"
              >
                <template slot="append">
                  <el-link class="empty vg_pointer" type="primary" @click="emptyChange">清空</el-link>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="样品编号：" prop="smpl_no" size="samll">
              <el-input v-model="readForm.smpl_no" :disabled="!isStpr" class="readInput">
                <template slot="append">
                  <el-link class="empty vg_pointer" type="primary" @click="reworkClick">选择</el-link>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="更改号：" prop="smpl_suffix" size="samll">
              <el-input v-model="readForm.smpl_suffix" class="readInput" disabled>
                <template slot="append">
                  <el-link class="empty vg_pointer" type="primary" @click="matchClick">匹配</el-link>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="样品数量：" prop="smpl_num" size="samll">
              <el-input v-model="readForm.smpl_num" :disabled="true" class="readInput"></el-input>
            </el-form-item>
            <el-form-item label="委托单号：" prop="requ_no" size="samll">
              <el-input v-model="readForm.requ_no" :disabled="true" class="readInput"></el-input>
            </el-form-item>
            <el-form-item label="工序：" prop="defa_proc" size="samll">
              <el-select
                v-model="readForm.defa_proc"
                :disabled="mode == 1"
                placeholder="请选择"
                popper-class="selectRead"
                @change="seChange"
              >
                <el-option v-for="item in proc_listc" :key="item.key" :label="item.label" :value="item.key"> </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-header>
        <div>
          <el-link v-if="mode == 1" :underline="false" class="retHome" type="primary" @click="returnHome">
            <i class="el-icon-d-arrow-left"></i> 返回首页</el-link
          >
        </div>
      </div>
      <el-main>
        <op-edi
          v-if="readForm.defa_proc === 'open'"
          ref="open"
          :prop="prop"
          :stffList="stffList"
          :stffList2="processList.open"
          @empty="empty"
        />
        <stpr
          v-if="readForm.defa_proc === 'stpr'"
          ref="stpr"
          :prop="prop"
          :stffList="stffList"
          :stffList2="processList.stpr"
          @empty="empty"
          @outSuccess="outSuccess"
          @smplNoSearch="smplNoSearch"
        />
        <mase
          v-if="readForm.defa_proc === 'mase'"
          ref="mase"
          :prop="prop"
          :stffList="stffList"
          :stffList2="processList.mase"
          @empty="empty"
        />
        <inspec
          v-if="readForm.defa_proc === 'insp'"
          ref="insp"
          :SmplId="SmplId"
          :prop="prop"
          :stffList="stffList"
          :stffList2="processList.insp"
          @empty="empty"
        />
        <manual
          v-if="readForm.defa_proc === 'manu'"
          ref="manu"
          :prop="prop"
          :stffList="stffList"
          :stffList2="processList.manu"
          @empty="empty"
        />
        <embr
          v-if="readForm.defa_proc === 'embr'"
          ref="embr"
          :prop="prop"
          :stffList="stffList"
          :stffList2="processList.embr"
          @empty="empty"
        />
        <lase
          v-if="readForm.defa_proc === 'lase'"
          ref="lase"
          :prop="prop"
          :stffList="stffList"
          :stffList2="processList.lase"
          @empty="empty"
        />
        <comp
          v-if="readForm.defa_proc === 'comp'"
          ref="comp"
          :prop="prop"
          :stffList="stffList"
          :stffList2="processList.comp"
          @empty="empty"
        />
        <stam
          v-if="readForm.defa_proc === 'stam'"
          ref="stam"
          :prop="prop"
          :stffList="stffList"
          :stffList2="processList.stam"
          @empty="empty"
        />
        <emcd
          v-if="readForm.defa_proc === 'emcd'"
          ref="emcd"
          :prop="prop"
          :stffList="stffList"
          :stffList2="processList.emcd"
          @empty="empty"
        />
        <hand
          v-if="readForm.defa_proc === 'handCut'"
          ref="handCut"
          :prop="prop"
          :stffList="stffList"
          :stffList2="processList.handCut"
          @empty="empty"
        />
        <typesetting
          v-if="readForm.defa_proc === 'typesetting'"
          ref="typesetting"
          :prop="prop"
          :stffList="stffList"
          :stffList2="processList.typesetting"
          @empty="empty"
        />
      </el-main>
    </el-card>
    <el-dialog :visible.sync="reworkFlag" title="选择重做货号" width="40%">
      <el-input v-model="dialog_rfid_no" class="readInput" maxlength="10" placeholder="请刷卡" show-word-limit @input="dialogCardChange">
        <template slot="append">
          <el-link
            class="empty vg_pointer"
            type="primary"
            @click="
              () => {
                dialog_rfid_no = '';
                reworkClick();
              }
            "
            >清空</el-link
          >
        </template>
      </el-input>
      <el-table ref="multiTable" :data="reworkTableData" border class="vg_cursor" @row-dblclick="reworkDBClick">
        <el-table-column label="序号" width="60">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="委托单号" prop="requ_no" />
        <el-table-column label="样品编号" prop="smpl_no" />
        <el-table-column label="更改号" prop="smpl_suffix" />
        <el-table-column label="样品名称" prop="smpl_name" />
        <el-table-column label="开版师" prop="smpl_stff_name" />
        <el-table-column label="样品类型" prop="smpl_type">
          <template v-slot="scope">
            <span>{{ scope.row.smpl_type === 1 ? '新款' : scope.row.smpl_type === 2 ? '老款' : '修改款' }}</span>
          </template>
        </el-table-column>
      </el-table>
      <pubPagination ref="pubPagination" :totalPage="reworkTotalPage" @changePageSearch="changePageSearch"></pubPagination>
    </el-dialog>
  </div>
</template>

<script>
import { get, getNoCatch } from '@api/request';
import { rfidAPI } from '@api/modules/rfid';
import { procAPI } from '@api/modules/proc';
import OpEdi from '@/views/OperateManagement/ReadManage/TabChild/OpEdi.vue';
import Stpr from '@/views/OperateManagement/ReadManage/TabChild/Stpr.vue';
import Mase from '@/views/OperateManagement/ReadManage/TabChild/Mase.vue';
import Inspec from '@/views/OperateManagement/ReadManage/TabChild/Inspec.vue';
import Manual from '@/views/OperateManagement/ReadManage/TabChild/Manual.vue';
import Embr from '@/views/OperateManagement/ReadManage/TabChild/Embr.vue';
import Lase from '@/views/OperateManagement/ReadManage/TabChild/Lase.vue';
import Comp from '@/views/OperateManagement/ReadManage/TabChild/Comp.vue';
import Stam from '@/views/OperateManagement/ReadManage/TabChild/Stam.vue';
import Emcd from '@/views/OperateManagement/ReadManage/TabChild/Emcd.vue';
import hand from '@/views/OperateManagement/ReadManage/TabChild/hand.vue';
import Typesetting from '@/views/OperateManagement/ReadManage/TabChild/Typesetting.vue';
import { smplAPI } from '@api/modules/smpl';
import pubPagination from '@/components/common/pubPagination.vue';
import { stffAPI } from '@api/modules/staff';
import { userAPI } from '@api/modules/user';

export default {
  name: 'readCard',
  components: {
    pubPagination,
    OpEdi,
    Stpr,
    Mase,
    Inspec,
    Manual,
    Embr,
    Lase,
    Comp,
    Stam,
    Emcd,
    hand,
    Typesetting
  },
  watch: {
    'readForm.defa_proc': function (newValue, oldValue) {
      this.isStpr = newValue === 'stpr';
    }
  },
  data() {
    return {
      isStpr: false,
      readForm: {
        rfid_no: '',
        smpl_no: '',
        requ_no: '',
        defa_proc: ''
      },
      procList: [
        { key: 'manu', label: '手工' },
        { key: 'insp', label: '检验' },
        { key: 'mase', label: '机缝' },
        { key: 'embr', label: '电绣' },
        { key: 'stam', label: '印花' },
        { key: 'lase', label: '激光' },
        { key: 'handCut', label: '手裁' },
        { key: 'comp', label: '复合' },
        { key: 'open', label: '开版' },
        { key: 'typesetting', label: '排版' },
        { key: 'stpr', label: '备料' },
        { key: 'emcd', label: '制卡' }
      ],
      procForm: {},
      // 员工拥有的所有工序
      proc_listc: [],
      eProcList: [],
      stffList: [],
      stffList2: [],
      prop: {
        user_id: '',
        stff_id: '',
        stff_name: '',
        open_status: '',
        rfid_id: '',
        user_rfid_no: '',
        mode: null,
        smpl_id: null,
        smpl_type: null
      },
      prop2: {},
      isDisabled: false,
      userName: '',
      SmplId: null,
      reworkFlag: false,
      reworkTableData: [],
      currentPage: 1,
      reworkTotalPage: 0,
      dialog_rfid_no: '',
      processList: {}
    };
  },
  methods: {
    // 根据样品编号获取RFID并查询
    smplNoSearch() {
      this.readForm.smpl_no = this.readForm.smpl_no.trim();
      get(rfidAPI.get_rfid_by_smpl_no, { smpl_no: this.readForm.smpl_no })
        .then(res => {
          if (res.data.code === 0) {
            this.readForm.rfid_no = res.data.data;
            this.cardChange(this.readForm.rfid_no);
          } else {
            this.$message({ message: res.data.msg, type: 'error' });
          }
        })
        .catch(res => {
          this.$message({ message: res, type: 'error' });
        });
    },
    getUserList() {
      get(userAPI.getAllUsersV1)
        .then(res => {
          if (res.data.code === 0) {
            let stffType = res.data.data.filter(item => item.dept_id === this.$cookies.get('userInfo').dept_id);
            let map = new Map();
            for (let item of stffType) {
              map.set(item.stff_name, item);
            }
            stffType = [...map.values()];
            this.stffList = stffType;
          }
        })
        .catch(() => {});
    },
    getStffList() {
      get(stffAPI.getAllStffsV1)
        .then(res => {
          if (res.data.code === 0) {
            let stffType = res.data.data.filter(item => item.dept_id === this.$cookies.get('userInfo').dept_id);
            let map = new Map();
            for (let item of stffType) {
              map.set(item.stff_name, item);
            }
            stffType = [...map.values()];
            this.stffList2 = stffType;
          }
        })
        .catch(() => {});
    },
    // 获取各个工序的员工
    obtainTheEmployeesOfEachProcess() {
      const temp = {}; // 动态存储各工序员工

      getNoCatch(procAPI.get_procs_v1, { dept_id: this.$cookies.get('userInfo').dept_id }).then(({ data }) => {
        data.list.forEach(row => {
          // 遍历每个工序缩写
          row.proc_codes.split(',').forEach(code => {
            const key = `${code}`;
            if (!temp[key]) temp[key] = [];
            temp[key].push(row);
          });
        });
      });
      this.processList = temp;
    },
    seChange(val) {
      this.readForm.defa_proc = val;
      if (this.readForm.rfid_no || this.readForm.smpl_no) {
        this.procForm.proc_defa = val;
        this.getData(this.readForm.defa_proc);
      } else {
        this.$nextTick(() => {
          this.$refs.cardRef.focus();
        });
      }
    },
    getProcForm() {
      get(procAPI.get_user_proc)
        .then(res => {
          if (res.data.code !== 0) {
            return this.$message.warning('请添加员工工序');
          }
          this.procForm = res.data.data.form;

          const proc_codes = this.procForm.proc_codes.split(',');
          for (const i in this.procList) {
            for (const j in proc_codes) {
              if (this.procList[i].key === proc_codes[j]) {
                this.proc_listc.push(this.procList[i]);
              }
            }
          }
          this.proc_listc.forEach(item => {
            this.eProcList.push(item.key);
          });
          if (this.$cookies.get('userMode').type === 0) {
            this.readForm.defa_proc = this.procForm.proc_defa;
          }
        })
        .catch(res => {
          const mg = res.data.msg;
          const tp = 'error';
          this.$message({ message: mg, type: tp });
        });
    },
    getCookie() {
      const userinfo = this.$cookies.get('userInfo');
      const mode = this.$cookies.get('userMode');
      this.mode = mode.type;

      this.prop.user_id = userinfo.user_id;
      this.prop.stff_id = userinfo.stff_id;
      this.prop.stff_name = userinfo.stff_name;
      this.prop.user_rfid_no = userinfo.rfid_no;
      this.prop.user_jobs = userinfo.user_jobs;
    },
    cardChange(val) {
      const trimValue = val.trim();
      if (trimValue.length === 10) {
        this.readForm.rfid_no = trimValue;
        this.getData(trimValue);
        this.isDisabled = true;
      }
    },
    dialogCardChange(val) {
      const trimValue = val.trim();
      if (trimValue.length === 10) {
        this.reworkClick();
      }
    },
    getData(val) {
      const process = this.readForm.defa_proc;
      let form = {
        rfid_no: this.readForm.rfid_no,
        proc_code: this.readForm.defa_proc
      };
      get(rfidAPI.read_card, form)
        .then(res => {
          if (res.data.code === 999) {
            this.isDisabled = false;
            this.empty();
            return this.$message.warning(res.data.msg);
          }
          if (res.data.code === 2) {
            this.readForm.rfid_no = '';
            this.$nextTick(() => {
              this.$refs.cardRef.focus();
            });
            this.empty();
            return this.$message.warning('该卡未开卡,请先开卡');
          }
          if (res.data.code !== 0) return this.$message.error(res.data.msg);
          if (res.data.code === 0) {
            this.SmplId = res.data.data.rfid.smpl_id;
            this.readForm.smpl_no = res.data.data.rfid.smpl_no;
            this.readForm.requ_no = res.data.data.rfid.requ_no;
            this.readForm.smpl_num = res.data.data.rfid.smpl_num;
            this.readForm.smpl_suffix = res.data.data.rfid.smpl_suffix;
            this.prop.open_status = res.data.data.rfid.open_status;
            this.prop.rfid_id = res.data.data.rfid.rfid_id;
            this.prop.smpl_id = res.data.data.rfid.smpl_id;
            this.prop.smpl_type = res.data.data.rfid.smpl_type;

            let { user_id, stff_id } = this.$cookies.get('userInfo');

            if (!res.data.data[process].card_user_id) res.data.data[process].card_user_id = user_id;
            if (!res.data.data[process].stff_id) res.data.data[process].stff_id = stff_id;

            const formatProcess = process === 'handCut' ? 'handcut' : process;
            this.prop[`rfid_${formatProcess}_id`] = res.data.data[process][`rfid_${formatProcess}_id`];

            let subTable = this.$refs[process]?.$refs?.subTable;
            if (subTable) {
              let rfidProcessItems = res.data.data[process]['rfidProcessItems'];
              let list = res.data.data[process]['list'];
              let rfid_typesetting_item = res.data.data[process]['rfid_typesetting_item'];

              if (rfidProcessItems && rfidProcessItems.length > 0) subTable.tableData = rfidProcessItems;
              if (list && list.length > 0) subTable.tableData = list;
              if (rfid_typesetting_item && rfid_typesetting_item.length > 0) subTable.tableData = rfid_typesetting_item;
            }
            this.prop2 = res.data.data[process];

            this.prop2.smpl_id = res.data.data.rfid.smpl_id;
            this.prop2.smpl_num = res.data.data.rfid.smpl_num;
            this.prop2.rfid_stpr_num = res.data.data.rfid.rfid_stpr_num;

            // 统一触发事件
            this.$EventBus.$emit(`${process}Emit`, this.prop2, res.data.data[process]?.smpl_mtrl_list);
          }
        })
        .catch(err => this.$message({ message: err, type: 'error' }));
    },
    emptyChange() {
      this.SmplId = null;
      this.readForm.rfid_no = '';
      this.readForm.smpl_no = '';
      this.readForm.requ_no = '';
      this.readForm.smpl_num = '';
      this.prop.open_status = '';
      this.prop.rfid_id = '';
      this.isDisabled = false;
      this.$nextTick(() => {
        this.$refs.cardRef.focus();
      });
      this.$EventBus.$emit(this.readForm.defa_proc);
    },
    empty() {
      this.readForm.rfid_no = '';
      this.readForm.smpl_no = '';
      this.readForm.requ_no = '';
      this.prop.open_status = '';
      this.prop.rfid_id = '';
      this.isDisabled = false;
      this.$nextTick(() => {
        this.$refs.cardRef.focus();
      });
    },
    outSuccess() {
      this.getData(this.readForm.defa_proc);
    },
    returnHome() {
      this.readForm.rfid_no = '';
      this.readForm.smpl_no = '';
      this.readForm.requ_no = '';
      this.prop.open_status = '';
      this.prop.rfid_id = '';
      this.isDisabled = false;
      this.emptyChange();
      this.jump('dashboard');
    },
    focus() {
      if (!this.$refs.cardRef) {
      } else {
        setTimeout(() => {
          this.$refs.cardRef.focus();
        }, 100);
      }
    },
    exitHome() {
      this.$cookies.remove('userInfo');
      this.$cookies.remove('push');
      this.$cookies.remove('userMode');
      this.jump('login');

      this.$cookies.set('loginType', false, 60 * 60 * 24 * 7);
    },
    reworkDBClick(row) {
      const process = this.readForm.defa_proc;
      const form = {
        smpl_id: row.smpl_id,
        proc_code: process
      };
      get(rfidAPI.read_card, form)
        .then(res => {
          if (res.data.code === 999) {
            this.isDisabled = false;
            this.empty();
            return this.$message.warning(res.data.msg);
          }
          if (res.data.code === 2) {
            this.readForm.rfid_no = '';
            this.$nextTick(() => {
              this.$refs.cardRef.focus();
            });
            this.empty();
            return this.$message.warning('该卡未开卡,请先开卡');
          }
          if (res.data.code === 0) {
            this.reworkFlag = false;
            this.SmplId = res.data.data.rfid.smpl_id;
            this.readForm.smpl_no = res.data.data.rfid.smpl_no;
            this.readForm.requ_no = res.data.data.rfid.requ_no;
            this.readForm.smpl_num = res.data.data.rfid.smpl_num;
            this.readForm.smpl_suffix = res.data.data.rfid.smpl_suffix;
            this.prop.open_status = res.data.data.rfid.open_status;
            this.prop.rfid_id = res.data.data.rfid.rfid_id;
            this.prop.smpl_id = res.data.data.rfid.smpl_id;
            this.prop.smpl_type = res.data.data.rfid.smpl_type;

            let { user_id, stff_id } = this.$cookies.get('userInfo');
            if (!res.data.data[process].card_user_id) res.data.data[process].card_user_id = user_id;
            if (!res.data.data[process].stff_id) res.data.data[process].stff_id = stff_id;
            this.prop2 = res.data.data[process];
            this.prop2.smpl_id = res.data.data.rfid.smpl_id;
            this.prop2.smpl_num = res.data.data.rfid.smpl_num;
            this.prop2.rfid_stpr_num = res.data.data.rfid.rfid_stpr_num;
            // 统一触发事件
            this.$EventBus.$emit(`${process}Emit`, this.prop2, res.data.data[process]?.smpl_mtrl_list);
          }
        })
        .catch(err => this.$message({ message: err, type: 'error' }));
    },
    reworkClick() {
      this.reworkFlag = true;
      getNoCatch(smplAPI.chooseToRedoData, { page_no: this.currentPage, rework_rfid_no: this.dialog_rfid_no }).then(({ data }) => {
        this.reworkTableData = data.list;
        this.reworkTotalPage = data.total;
      });
    },
    matchClick() {
      const process = this.readForm.defa_proc;
      let form = {
        smpl_no: this.readForm.smpl_no,
        smpl_suffix: this.readForm.smpl_suffix,
        smpl_id: this.SmplId,
        proc_code: this.readForm.defa_proc
      };
      getNoCatch(rfidAPI.getmatchSampleData, form).then(res => {
        let { user_id, stff_id } = this.$cookies.get('userInfo');
        this.prop2 = res.data[process];
        this.prop2.card_user_id = user_id;
        this.prop2.stff_id = stff_id;
        this.prop2.smpl_id = this.SmplId;
        this.prop2.smpl_num = this.readForm.smpl_num;
        this.prop2.matchClickStatus = true;

        // 统一触发事件
        this.$EventBus.$emit(`${process}Emit`, this.prop2, res.data[process]?.smpl_mtrl_list);
      });
    },
    changePageSearch(val) {
      this.currentPage = val;
      this.reworkClick();
    }
  },
  mounted() {
    this.$refs.cardRef.focus();
    if (this.$cookies.get('userMode').type === 1) {
      this.readForm.defa_proc = this.$route.query.proc;
    }
    this.$EventBus.$on('openRead', () => {
      setTimeout(() => {
        this.focus();
      }, 500);
    });
    this.userName = this.$cookies.get('userInfo').stff_name;
  },
  created() {
    this.getProcForm();
    this.getCookie();
    this.getUserList();
    this.getStffList();
    this.obtainTheEmployeesOfEachProcess();
  }
};
</script>

<style lang="scss">
.retHome {
  float: left;
  height: 85px;
  font-size: 20px;
  text-align: center;
}
.readForm .el-form-item__label {
  font-size: $font-max;
}
.readInput {
  margin-bottom: 10px !important;
  font-size: $font-max;
  height: 50px;
}
.readInput input {
  height: 50px;
}
.clearfix::after {
  content: '';
  clear: both;
  display: table;
}
.topHeader {
  display: flex;
  border-bottom: 2px dotted #cccccc;
}

.head_read {
  width: 75%;
  float: left;
  padding-bottom: 20px;
  height: 355px !important;
}
.readForm {
  width: 75%;
  margin: 0 auto;
  min-width: 500px;
}
.empty {
  font-size: $font-max;
}

.readForm .el-input__inner {
  font-size: $font-max;
  height: 50px;
}

.selectRead li {
  font-size: $font-max;
  height: 60px;
  line-height: 60px;
}
.userName {
  font-size: 20px;
  span {
    font-weight: 700;
    font-size: 28px;
  }
}
</style>
